import { useEffect } from "react";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const useAssinarAtividadePadrao = ({ data, atividade, formik }) => {
  const {
    request: assinarRequest,
    data: assinarData,
    errors: assinarErrors,
    isLoading: assinarIsLoading,
  } = useApiClient();

  const assinarAtividade = () => {
    const parametros = {
      sequencialOrdemServico: data.dadosOs.sequencial,
      sequencialAcaoFiscal: data.dadosOs.acaoFiscal,
      sequencialProdutoAcaoFiscal: data.sequencialAuto,
      sequencialAtividade: atividade.sequencialAtividade,
      sequencialAndamento: formik.values.sequencialUltimoAndamento,
      nomeAtividade: atividade.nomeAtividade,
      siglaAtividade: atividade.siglaAtividade,
      numAutoInfracao: data.numAutoInfracao,
      txPreliminares: formik.values.txPreliminares,
      txProcedimentos: formik.values.txProcedimentos,
      txConstatacoes: formik.values.txConstatacoes,
      txOcorrencias: formik.values.txOcorrencias,
      txResultado: formik.values.txResultado,
      textoDocumento: formik.values.textoDocumento,
      cpfRepresentante: formik.values?.cpfRepresentante,
      nomeRepresentante: formik.values?.nomeRepresentante,
      cargoRepresentante: formik.values?.cargoRepresentante,
      dataCiencia: formik.values?.dataCiencia,
      nomeTestemunha: formik.values?.nomeTestemunha,
      cpfTestemunha: formik.values?.cpfTestemunha,
      dataRecusa: formik.values?.dataRecusa,
    };

    assinarRequest(apiRoutes.fiscalizacao.autoinfracao.assinarAtividadePadrao, parametros);
  };

  useEffect(() => {
    if (assinarIsLoading) return;

    if (!assinarData && !assinarErrors) return;

    if (assinarData) {
      toast.success("Documento da atividade assinado com sucesso.");
      window.location.reload();
    }
  }, [assinarData, assinarErrors, assinarIsLoading]);

  return { assinarIsLoading, assinarAtividade, assinarErrors };
};

export default useAssinarAtividadePadrao;
